import React, { useState, useEffect, useRef } from "react";
import InfiniteLogoSlider from "react-infinite-logo-slider";
import "./logo-carousel.scss";

const logos = [
  { src: "/img/customers/lego.jpg", alt: "LEGO" },
  {
    src: "/img/customers/bgw.png",
    alt: "BGW - Berufsgenossenschaft für Gesundheitsdienst und Wohlfahrtspflege",
  },
  { src: "/img/customers/messe-muenchen.png", alt: "Messe München" },
  { src: "/img/customers/boeringer-ingelheim.jpg", alt: "Boeringer Ingelheim" },
  { src: "/img/customers/flughafen-stuttgart.png", alt: "Flughafen Stuttgart" },
  { src: "/img/customers/ifo-institut.png", alt: "IFO Institut" },
  { src: "/img/customers/mitsubishi.png", alt: "Mitsubishi" },
  { src: "/img/customers/ipk.png", alt: "IPK International" },
  { src: "/img/customers/palfinger.png", alt: "Palfinger" },
  { src: "/img/customers/deka.png", alt: "DEKA Investments" },
  { src: "/img/customers/uefa.png", alt: "UEFA" },
  { src: "/img/customers/laerdal.png", alt: "Laerdal Medical" },
];

const LogoCarousel: React.FC = () => {
  const [logoWidth, setLogoWidth] = useState(160); // Default width for each logo
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const updateLogoWidth = () => {
      if (containerRef.current) {
        const containerWidth = containerRef.current.offsetWidth;
        const calculatedWidth = Math.max(
          containerWidth / logos.length - 20,
          160
        ); // Min width 80px
        setLogoWidth(calculatedWidth);
      }
    };

    updateLogoWidth();
    window.addEventListener("resize", updateLogoWidth);
    return () => window.removeEventListener("resize", updateLogoWidth);
  }, []);

  return (
    <div ref={containerRef} className="logo-carousel-container">
      <InfiniteLogoSlider pauseOnHover>
        {logos.map((logo, index) => (
          <InfiniteLogoSlider.Slide key={index}>
            <div
              style={{
                width: `${logoWidth}px`,
                margin: "0 0",
                textAlign: "center",
              }}
            >
              <img
                src={logo.src}
                alt={logo.alt}
                style={{
                  maxWidth: "160px",
                  height: "4rem",
                  maxHeight: "4rem",
                  objectFit: "contain",
                }}
              />
            </div>
          </InfiniteLogoSlider.Slide>
        ))}
      </InfiniteLogoSlider>
    </div>
  );
};

export default LogoCarousel;
